/**
 * String helper utilities for chat-ui
 */

/**
 * Extract initials from a name.
 *
 * @param name - Full name or email to extract initials from
 * @returns Uppercase initials (2 characters max)
 *
 * @example
 * getInitials('John Doe') // 'JD'
 * getInitials('Jane') // 'JA'
 * getInitials('john.doe@example.com') // 'JO'
 */
export function getInitials(name?: string): string {
  if (!name) {
    return '?';
  }

  const trimmed = name.trim();
  const parts = trimmed.split(/\s+/);

  if (parts.length >= 2) {
    const first = parts[0]?.[0] ?? '';
    const last = parts[parts.length - 1]?.[0] ?? '';
    return `${first}${last}`.toUpperCase();
  }

  return trimmed.slice(0, 2).toUpperCase();
}
